module.exports = __webpack_public_path__ + "img/ve3.e639443d.png";